import { PostEditorEffectArgs } from '../PostEditorEffects';
import { expandAndScrollToFirstPostEditorError } from './submitEditor.effect';

export const expandPostGroupEffect: PostEditorEffectArgs = (_, effect) => {
  const { payload: ref } = effect;
  setTimeout(() => {
    expandAndScrollToFirstPostEditorError(ref);
  }, 360);
};
